<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg900"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs904"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath914"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path912" /></clipPath><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath928"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path926" /></clipPath></defs><g
     id="g906"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g908"><g
         id="g910"
         clip-path="url(#clipPath914)"><g
           id="g916"
           transform="translate(10,408.5)"><path
             d="m 0,0 v -352.5 h 492 v 400 H 0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:1000, 45, 0, 45, 1000;stroke-dashoffset:0;stroke-opacity:1"
             id="path918" /></g></g></g><path
       d="M 428,56 H 276 v 312 h 152 z"
       style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path920" /><g
       id="g922"><g
         id="g924"
         clip-path="url(#clipPath928)"><path
           d="M 10,166 H 276 V 126 H 10 Z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path930" /><path
           d="M 50,56 H 10 v 70 h 40 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path932" /><g
           id="g934"
           transform="translate(10,166)"><path
             d="M 0,0 V 20 C 0,31.046 8.954,40 20,40 H 60 C 71.046,40 80,31.046 80,20 V 0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path936" /></g><path
           d="m 276,56 h -40 v 70 h 40 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path938" /><path
           d="m 388,288 h -72 v 40 h 72 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path940" /><g
           id="g942"
           transform="translate(388,212)"><path
             d="M 0,0 H -20"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path944" /></g><g
           id="g946"
           transform="translate(10,376)"><path
             d="M 0,0 V 80 H 80 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path948" /></g><g
           id="g950"
           transform="translate(502,376)"><path
             d="M 0,0 V 80 H -80 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path952" /></g><g
           id="g954"
           transform="translate(422,56)"><path
             d="M 0,0 H 80 V 80 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path956" /></g></g></g></g></svg>
</template>
